"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VenueAirportTransportMethod = void 0;
var VenueAirportTransportMethod;
(function (VenueAirportTransportMethod) {
    VenueAirportTransportMethod["DRIVE"] = "drive";
    VenueAirportTransportMethod["WALK"] = "walk";
    VenueAirportTransportMethod["FERRY"] = "ferry";
    VenueAirportTransportMethod["BUS"] = "bus";
    VenueAirportTransportMethod["TRAIN"] = "train";
})(VenueAirportTransportMethod = exports.VenueAirportTransportMethod || (exports.VenueAirportTransportMethod = {}));
//# sourceMappingURL=airports.js.map